import React from "react";
import { SubmitBar } from "@egovernments/digit-ui-react-components";
import ButtonWrapper from "../../../TCPForms/components/Button";
import { useHistory } from "react-router-dom/cjs/react-router-dom";

const SubStep2 = ({ formData, tenantId, handleTabChange }) => {
  const history = useHistory();

  return (
    <div>
      <div>PRESS RELEASE FEE:</div>
      <strong>{`₹ ${formData?.pressReleaseAmount || formData?.additionalDetails?.pressReleaseFee || formData?.pressReleaseFee || 0}`}</strong>
      <ButtonWrapper
        variant="contained"
        color="success"
        size="medium"
        label={"Make Payment"}
        type="submit"
        sx={{ backgroundColor: "#157CB3", width: "150px", letterSpacing: "normal" }}
        onClick={() => handleTabChange(1, formData)}
      />
    </div>
  );
};

export default SubStep2;
